import style from './style.css';

const UserCountTag = ({ isCampaignPage }) => {
  return (
    <div className={style.gradientBorder}>
      <div className={style.userCountContainer}>
        <div className={style.userCountImageContainer}>
          <img
            className={style.userImage}
            src='https://iccdn.in/img/ic_user-count-image.png'
            alt='user group image'
          />
        </div>
        <div
          className={`${style.userCountTextContainer} ${isCampaignPage &&
            style.userCountTextContainerCampaign}`}>
          <div
            className={`${style.userCountText} ${isCampaignPage &&
              style.userCountTextCampaign}`}>
            4.5+ Crore
          </div>
          <div
            className={`${style.userStateText} ${isCampaignPage &&
              style.userStateTextCampaign}`}>
            preapproved users
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserCountTag;



// WEBPACK FOOTER //
// ./routes/program-landing-page/components/usersCountTag/index.js